function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import appApis from '@/services/services';
import assignments_service from '@/apps/data-platform/services/tables_views/assignments_service';
import TablesService from '@/apps/data-platform/services/tables_views/tables_service';
import { textsDefaul, envConfig, TAG_QUERIES, DEFAULT_TPL_FIELDS, UI_CUSTOM_PERMISIONS, TYPE_CHANGE_METADA, ROLES_LIST } from '@/js/constants';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import ProfilingExecuteItem from '@/components/profiling/ProfilingExecuteItem';
import ModalProfilingRules from '@/views/profiling/ModalProfilingRules';
import HistoryItem from '@/views/profiling/HistoryItem';
import ModalAccess from '@/components/ModalAccess';
import FormMetadata from '@/components/FormMetadata.vue';
import FormAssignTemporalOwner from '@/components/FormAssignTemporalOwner.vue';
import PaginationSearching from '@/components/refactoring/PaginationSearching.vue';
import SearchInTableNew from '@/components/refactoring/SearchInTable.vue';
export default {
  name: 'ContMyTables',
  components: {
    ProfilingExecuteItem: ProfilingExecuteItem,
    ModalProfilingRules: ModalProfilingRules,
    HistoryItem: HistoryItem,
    ModalAccess: ModalAccess,
    FormMetadata: FormMetadata,
    FormAssignTemporalOwner: FormAssignTemporalOwner,
    PaginationSearching: PaginationSearching,
    SearchInTableNew: SearchInTableNew
  },
  data: function data() {
    return {
      MODAL_NAME_METADATA: 'ContTablesMeMetadata',
      MODAL_NAME_OWNER: 'ContTablesMeOwner',
      MODAL_NAME_ALL_OWNER: 'ContTablesMeOwnerAll',
      MODAL_NAME_METADATA_VIEW: 'ListObjectsSearchMetadataView',
      MODAL_NAME_PROFILING_VIEW: 'ContTableProfiling',
      MODAL_CONFIRM_EXECUTE_PROFILING: 'MODAL_CONFIRM_EXECUTE_PROFILING',
      MODAL_PROFILING_RULES: 'MODAL_PROFILING_RULES',
      MODAL_LIST_ACCESS: 'MODAL_LIST_ACCESS',
      TYPE_CHANGE_METADA: TYPE_CHANGE_METADA,
      collapse_filter: false,
      queryResponse: null,
      searchOwnTables: '',
      tplToUpdate: {},
      PAGE_SIZE: envConfig.pagintaionSize,
      PAGE_TAGS_SIZE: envConfig.pagintaionTagsSize,
      Q_DEFAULT: TAG_QUERIES.MY_TABLES.replace('${email}', window.userInfo.email),
      messageEmptyList: textsDefaul.LOADING,
      filter: '',
      filterOn: [],
      paramsSearch: {},
      isNewQuery: true,
      defaultDomain: window.userInfo.domain,
      currentEmail: window.userInfo.email,
      listAccessTables: {},
      userHasPermission: false,
      title_modal: '',
      data_ds: null,
      path_name: '',
      dismissCountDown: 0,
      dismissSecs: 8,
      dangerMessage: '',
      response_text: '',
      limit: envConfig.pagintaionSize,
      tableExecute: Object,
      item: Object,
      tableReference: Object,
      paginationObj: {
        offset: 0
      }
    };
  },
  props: {
    showDomains: {
      type: Boolean,
      required: false,
      default: true
    },
    approvalFlow: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    tableFields: function tableFields() {
      return [{
        key: '↕',
        variant: 'return-sort',
        class: 'w-2'
      }, {
        label: this.traductor('tablas.table'),
        key: 'tableReference.tableId',
        sortable: true,
        class: 'text-left w-30'
      }, {
        label: this.traductor('tablas.enviroment'),
        key: "defaultFields.".concat(DEFAULT_TPL_FIELDS.ENVIRONMENT.name, ".enumValue.displayName"),
        class: 'w-10',
        sortable: true,
        align: 'center'
      }, {
        label: this.traductor('tablas.columns'),
        key: 'schema.fields.length',
        class: 'w-8',
        sortable: true,
        align: 'center'
      }, {
        label: this.traductor('tablas.rows'),
        key: 'numRows',
        class: 'w-5',
        sortable: true,
        align: 'center'
      }, {
        label: this.traductor('tablas.creation_time'),
        key: 'creationTime',
        class: 'w-15',
        sortable: true,
        align: 'center'
      }, {
        label: this.traductor('tablas.actions'),
        key: 'actions',
        class: 'text-left w-20',
        align: 'center'
      }];
    },
    no_tables: function no_tables() {
      return this.traductor('frases.no_tables');
    },
    isEmptyTable: function isEmptyTable() {
      return !(this.queryResponse && this.queryResponse.tables && this.queryResponse.tables.length);
    },
    hideAssignAllTables: function hideAssignAllTables() {
      var _this = this;
      var list_env = [];
      var data = {};
      if (this.queryResponse && this.queryResponse.tables && this.queryResponse.tables.length && !this.approvalFlow) {
        var _iterator = _createForOfIteratorHelper(this.queryResponse.tables),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var table = _step.value;
            data = {
              env: table.defaultFields.env.enumValue.displayName,
              operator: table.defaultFields.operator.stringValue
            };
            list_env.push(data);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      return list_env.some(function (item) {
        return item.env === 'prod' && item.operator === _this.currentEmail;
      });
    },
    hasDataQualityPermission: function hasDataQualityPermission() {
      return utils.hasRole(ROLES_LIST.DATAQUALITY_OPERATOR) || utils.hasRole(ROLES_LIST.ORG_DATA_STEWARD);
    },
    rows: function rows() {
      return this.queryResponse.tables.length;
    }
  },
  created: function created() {
    if (window.userInfo.isSignIn) {
      window.userInfo.isSignIn = false;
      setTimeout(function () {
        location.reload();
      }, 500);
    }
    if (window.userInfo.isSignIn === undefined) {
      this.reloadList();
    }
    this.userHasPermission = this.hasPermission();
  },
  methods: {
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    hasPermission: function hasPermission() {
      var roles = UI_CUSTOM_PERMISIONS['SYNC_TABLE']['roles'];
      var status = false;
      var _iterator2 = _createForOfIteratorHelper(roles),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var rol = _step2.value;
          if (utils.hasRole(rol)) {
            status = true;
            break;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return status;
    },
    asyncTableWithSchema: function asyncTableWithSchema(row) {
      var _this2 = this;
      var rowData = utils.cloneJSON(row.item);
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table
      };
      assignments_service.syncTableSchema(params).then(function (response) {
        if (response.code === 200) {
          var message = response.message;
          tasks.toast.success(message);
          //this.$toast.success(message)
          row.item.columns_change = false;
          var index = _this2.queryResponse.tables.indexOf(row.item);
          if (index != -1) {
            console.log(index);
            _this2.queryResponse.tables[index].columns_change = false;
            _this2.$set(_this2.queryResponse.tables[index], 'columns_change', false);
            _this2.$refs['my-tables-operator'].$forceUpdate();
          }
        }
      }).catch(function (e) {
        utils.printError(e);
      });
    },
    generateViewUrl: function generateViewUrl(row) {
      console.log(row);
      var _row$tableReference = row.tableReference,
        tableId = _row$tableReference.tableId,
        datasetId = _row$tableReference.datasetId,
        projectId = _row$tableReference.projectId;
      var id = "".concat(projectId, ".").concat(datasetId, ".").concat(tableId);
      if (this.listAccessTables[id]) {
        window.open(this.listAccessTables[id].viewUrl, '_blank');
      } else {
        tasks.toast.error(no_tables);
        this.$toast.warning(no_tables);
      }
    },
    goLink: function goLink(event, data) {
      event.preventDefault();
      this.$router.push({
        path: "/metadata/detail/".concat(data.item.tagTemplateId)
      });
      return true;
    },
    sendToFilter: function sendToFilter(q) {
      this.filter = q;
      return true;
    },
    sendToSearch: function sendToSearch(q, domain, allDomains) {
      var conditions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      this.Q_DEFAULT = TAG_QUERIES.MY_TABLES.replace('${email}', window.userInfo.email);
      this.Q_DEFAULT = "".concat(this.Q_DEFAULT, " ").concat(q);
      var params = {
        query: this.Q_DEFAULT,
        domain: domain,
        allDomains: allDomains,
        conditions: conditions
      };
      this.isNewQuery = true;
      this.reloadList(params); // reload list
    },
    openAllTempOwner: function openAllTempOwner() {
      this.$bvModal.show(this.MODAL_NAME_ALL_OWNER);
      return true;
    },
    openTempOwner: function openTempOwner(item) {
      var _this3 = this;
      this.tplToUpdate = utils.cloneJSON(item);
      var rowData = utils.cloneJSON(item);

      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table
      };
      // get template fields
      assignments_service.getListTagEntry(params).then(function (response) {
        if (response.code === 200) {
          _this3.tplToUpdate = response.data;
          _this3.tplToUpdate.item = rowData;
          _this3.$bvModal.show(_this3.MODAL_NAME_OWNER);
        }
      }).catch(function (e) {
        utils.printError(e);
        _this3.openTempOwner(item);
      });
      // this.itemOpen = item
      return true;
    },
    assignOwner: function assignOwner() {
      this.$bvModal.hide(this.MODAL_NAME_OWNER);
      this.reloadList();
      return true;
    },
    assignAllOwner: function assignAllOwner() {
      this.$bvModal.hide(this.MODAL_NAME_ALL_OWNER);
      this.reloadList();
      return true;
    },
    openEditTpl: function openEditTpl(item, modalName) {
      var _this4 = this;
      // properties: item, index, event
      var i;
      var rowData = utils.cloneJSON(item);
      // validate user info
      var userLogin = window.userInfo && window.userInfo.userLogin;
      if (!userLogin) return false;
      var params = {
        relativeResourceName: rowData.relativeResourceName,
        pageSize: this.PAGE_TAGS_SIZE,
        email: userLogin.email,
        index_node: rowData.index_node,
        domain_table: rowData.domain_table
      };
      // get template fields
      assignments_service.getListTagEntry(params).then(function (response) {
        if (response && response.code === 200) {
          var responseTPL = response.data;
          for (i = 0; i < responseTPL.objects.tags.length; i++) {
            if (!responseTPL.objects.tags[i].fields.business_term) {
              if (responseTPL.objects.tags[i].column) {
                responseTPL.objects.tags[i].fields.business_term = {};
                responseTPL.objects.tags[i].fields.business_term.displayName = 'Business Term';
                responseTPL.objects.tags[i].fields.business_term.stringValue = '';
              }
            }
          }
          _this4.tplToUpdate = responseTPL;
          _this4.tplToUpdate.item = rowData;
          _this4.tplToUpdate.tipo = 'edicion';
          _this4.tplToUpdate.origin = 'mytables';
          _this4.$bvModal.show(modalName);
        } else {
          _this4.reloadList();
        }
      }).catch(function (e) {
        utils.printError(e);
        _this4.openEditTpl(item, modalName);
      });
      return true;
    },
    saveTags: function saveTags() {
      this.$bvModal.hide(this.MODAL_NAME_METADATA);
      this.reloadList();
      return true;
    },
    processAccessTables: function processAccessTables(tables) {
      var newTables = {};
      if (tables) {
        tables.sort(function (a, b) {
          return a.creationTime - b.creationTime;
        }).reverse().map(function (t) {
          var _t$Table = t.Table,
            objectId = _t$Table.objectId,
            datasetId = _t$Table.datasetId,
            projectId = _t$Table.projectId;
          var id = "".concat(projectId, ".").concat(datasetId, ".").concat(objectId);
          if (newTables[id] === undefined) {
            var v_tableId = t.View.objectId;
            var v_datasetId = t.View.datasetId;
            var v_projectId = t.View.projectId;
            var url = "https://console.cloud.google.com/bigquery?p=".concat(v_projectId, "&d=").concat(v_datasetId, "&page=table&t=").concat(v_tableId, "&project=").concat(v_projectId, "&authuser=1");
            newTables[id] = _objectSpread(_objectSpread({}, t.View), {}, {
              viewUrl: url,
              creationTime: t.creationTime,
              permissionExpirationDate: t.permissionExpirationDate
            });
          }
        });
      }
      this.listAccessTables = newTables;
    },
    processParams: function processParams(params) {
      var _ref = params || {},
        _ref$email = _ref.email,
        email = _ref$email === void 0 ? window.userInfo.email : _ref$email,
        _ref$domain = _ref.domain,
        domain = _ref$domain === void 0 ? window.userInfo.domain : _ref$domain,
        _ref$query = _ref.query,
        query = _ref$query === void 0 ? this.Q_DEFAULT || '' : _ref$query,
        _ref$pageSize = _ref.pageSize,
        pageSize = _ref$pageSize === void 0 ? this.PAGE_SIZE : _ref$pageSize,
        _ref$searchWithTags = _ref.searchWithTags,
        searchWithTags = _ref$searchWithTags === void 0 ? true : _ref$searchWithTags,
        _ref$allDomains = _ref.allDomains,
        allDomains = _ref$allDomains === void 0 ? false : _ref$allDomains,
        _ref$approval_flow = _ref.approval_flow,
        approval_flow = _ref$approval_flow === void 0 ? this.approvalFlow : _ref$approval_flow,
        _ref$nextToken = _ref.nextToken,
        nextToken = _ref$nextToken === void 0 ? undefined : _ref$nextToken,
        _ref$conditions = _ref.conditions,
        conditions = _ref$conditions === void 0 ? undefined : _ref$conditions,
        _ref$getAccessTables = _ref.getAccessTables,
        getAccessTables = _ref$getAccessTables === void 0 ? true : _ref$getAccessTables;
      this.paramsSearch = nextToken === undefined ? {
        email: email,
        domain: domain,
        query: query,
        pageSize: pageSize,
        searchWithTags: searchWithTags,
        allDomains: allDomains,
        approval_flow: approval_flow,
        nextToken: nextToken,
        conditions: conditions,
        getAccessTables: getAccessTables
      } : _objectSpread(_objectSpread({}, this.paramsSearch), {}, {
        nextToken: nextToken
      });
      return this.paramsSearch;
    },
    reloadList: function reloadList(params) {
      var _this5 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var defaultParams = this.processParams(params);
      if (this.approvalFlow) {
        defaultParams['paginationObj'] = this.paginationObj;
      }
      var self = this;
      var request = this.approvalFlow ? TablesService.queryTables(defaultParams) : appApis.queryServiceNew(defaultParams);
      request.then(function (response) {
        if (response && response.code === 200) {
          self.queryResponse = response.data || {};
          self.processAccessTables(self.queryResponse.list_access_tables);
          tasks.combineTagsInRows(self.queryResponse);
          self.verifyColumnsWithoutTags();
          self.messageEmptyList = !response.data.tables.length ? _this5.no_tables : null;
          if (_this5.approvalFlow) {
            _this5.paginationObj = response.data.pagination;
          }
        } else if (response && response.code === 400) {
          console.log(response.code, response.message);
        }
        _this5.isNewQuery = false;
        callback && callback(response);
      }).catch(function (e) {
        utils.printError(e);
        self.messageEmptyList = 'The request was interrupted, try again';
      });
    },
    goPaginate: function goPaginate(type) {
      switch (type) {
        case 'FIRST':
          this.paginationObj.offset = 0;
          break;
        case 'NEXT':
          this.paginationObj.offset = this.paginationObj.next;
          break;
        case 'PREV':
          this.paginationObj.offset = this.paginationObj.previous;
          break;
      }
      this.reloadList();
    },
    closeExecuteItem: function closeExecuteItem() {
      this.$bvModal.hide(this.MODAL_CONFIRM_EXECUTE_PROFILING);
    },
    openModal: function openModal(item, modalName) {
      this.tableReference = item;
      this.showModal(modalName);
    },
    showModal: function showModal(modalName) {
      this.$bvModal.show(modalName);
    },
    hideModal: function hideModal(modalName) {
      this.$bvModal.hide(modalName);
    },
    viewDetail: function viewDetail(item) {
      this.hideModal(this.MODAL_PROFILING_RULES);
      this.item = item;
      this.showModal(this.MODAL_NAME_PROFILING_VIEW);
    },
    getTableFields: function getTableFields() {
      if (this.approvalFlow) {
        return this.tableFields.filter(function (e) {
          return e.label !== 'Environment';
        });
      }
      return this.tableFields;
    },
    verifyColumnsWithoutTags: function verifyColumnsWithoutTags() {
      var _iterator3 = _createForOfIteratorHelper(this.queryResponse.tables),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          var tags = item.tags;
          var tag_dict = {};
          var _iterator4 = _createForOfIteratorHelper(tags),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var tag = _step4.value;
              if ('column' in tag && tag.templateDisplayName.toLowerCase() == 'tpl_columns') {
                tag_dict[tag.column.toLowerCase()] = tag;
              }
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          var total_columns_with_tag = 0;
          var _iterator5 = _createForOfIteratorHelper(item.schema.fields),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var column = _step5.value;
              if (column.name.toLowerCase() in tag_dict) {
                total_columns_with_tag += 1;
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
          if (total_columns_with_tag != item.schema.fields.length) {
            item.columns_change = true;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      console.log(this.queryResponse.tables);
    },
    classColumnsChange: function classColumnsChange() {
      return function (row) {
        return {
          'font-weight-bold text-danger': row.item.columns_change
        };
      };
    }
  }
};